import {environment} from '@environments/environment';
import {Brand, CsslBrand, IAuthInfo} from '@service-and-repairs/awpintegrationlib';
import {UserData} from '../core/user/models/user-data';
import {Util} from '../util/util';
import {CsslToken} from './cssl/cssl-token';
import {OidcToken} from './oidc/oidc-token';

export class AuthInfoFactory {
  static makeAuthInfo(user: UserData, brand: string): IAuthInfo {
    const oidcToken = OidcToken.readFromStorage(user.getContext());
    const csslToken = CsslToken.readFromStorage(user.getContext());
    if (!oidcToken.access_token) {
      console.error(Util.logPrefix('Webapp', 'Auth') +
        `Creating incomplete 'auth-info' object: OIDC access token is missing in local storage.`);
    }
    if (!csslToken.jwt) {
      console.error(Util.logPrefix('Webapp', 'Auth') +
        `Creating incomplete 'auth-info' object: CSSL token is missing in local storage.`);
    }

    return {
      wenOidcAccessToken: oidcToken.access_token,
      csslToken: csslToken.jwt,
      authScheme: user.getAuthScheme(),
      authRealm: user.getAuthRealm(),
      countryCode: user.getB2XCountryCode(),
      environment: environment.deploymentEnvironment,
      businessContext: user.getContext(),
      roles: user.getRoles(),
      brands: AuthInfoFactory.awpBrandsToCsslBrands(user.getBrandsOfSelectedBusinessPartner()),
      distributionPartnerNumber: user.getBusinessPartner().getDistributionPartnerNumber(),
      outletNumber: user.getBusinessPartner().getOutletNumber(),
      businessNumber: user.getBusinessNumber(brand)
    };
  }

  static awpBrandsToCsslBrands(brands: Brand[]): CsslBrand[] {
    if (brands?.length > 0) {
      return brands.map(AuthInfoFactory.awpBrandToCsslBrand);
    } else {
      console.error(Util.logPrefix('Webapp', 'Auth') +
        `Creating incomplete 'auth-info' object: List of AWP brands is undefined or empty.`);
      return [];
    }
  }

  static awpBrandToCsslBrand(brand: Brand): CsslBrand {
    switch (brand) {
      case Brand.BMW:
        return CsslBrand.BMW;
      case Brand.BMW_i:
        return CsslBrand.BMW_I;
      case Brand.MINI:
        return CsslBrand.MINI;
      case Brand.MOT:
        return CsslBrand.BMW_MOTORCYCLE;
      case Brand.RR:
        return CsslBrand.ROLLS_ROYCE;
      case Brand.C_1:
        return CsslBrand.C_1;
      case Brand.ZINORO:
        return CsslBrand.BMW_ZINORO;
      case Brand.HUSQVARNA:
        return CsslBrand.HUSQVARNA;
      case Brand.TOYOTA:
        console.warn(Util.logPrefix('Webapp', 'Auth') + 'AWP brand TOYOTA cannot be mapped to CSSL brand');
        return CsslBrand.UNKNOWN;
      case Brand.UNKNOWN:
      default:
        console.warn(Util.logPrefix('Webapp', 'Auth') + `Unknown AWP brand ${brand} cannot be mapped to CSSL brand`);
        return CsslBrand.UNKNOWN;
    }
  }
}
